import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup as MuiRadioGroup,
  Box,
  Typography,
} from "@mui/material";
import { TkRadioGroupProps } from "../../../type/componentsType/TkRadioGroup";
import type { RadioGroupProps as MuiRadioGroupProps } from "@mui/material";
import "./_style.scss";

/**
 * ラジオボタングループ部品
 * radioPropsで渡した配列の要素を項目とするラジオボタンを表示する
 * @param {string} errorMessage {errors.スキーマで定義した名前?.message}で設定
 * @param {[{value: string, label: string}]} radioProps
 * @param {boolean} row trueで縦並び　falseで横並び
 * @param {boolean} disabled trueで非活性　falseで活性
 * @param {string} selected 初期表示で選択させる要素の番号を文字列で設定
 * @param rest オプション
 * @return TkRadioGroup ラジオボタングループ部品
 */
export const TkRadioGroup: React.FC<TkRadioGroupProps & MuiRadioGroupProps> = ({
  inputRef,
  errorMessage,
  radioPropsList,
  row,
  onChange,
  onClick,
  onGetValue,
  disabled,
  selected,
  lineClassName,
  isGuideMessage,
  guideMessage,
  wantToSetValue,
  ...rest
}) => {
  const [selectedValue, setSelectedValue] = useState(wantToSetValue || "");
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    setSelectedValue(wantToSetValue || "");

    if (wantToSetValue !== null && wantToSetValue !== undefined) {
      const defaultValue = {
        target: {
          value: wantToSetValue,
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange && onChange(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  const click = (event: any) => {
    if (disabled) return;
    if (selectedValue === event.target.value && isClicked) {
      setSelectedValue("");

      setIsClicked(() => {
        if (isClicked) {
          onGetValue && onGetValue("");
          onChange && onChange(undefined);
        }

        return !isClicked;
      });
    }

    onClick && onClick(event);
  };

  const change = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
    onGetValue && onGetValue(event.target.value);
    onChange && onChange(event);
    setIsClicked(true);
  };

  return (
    <Box className="TkRadioGroup">
      <FormControl onChange={change} onClick={click}>
        <MuiRadioGroup
          ref={inputRef}
          {...rest}
          row={row === undefined ? true : row === false}
          value={selectedValue}
        >
          {radioPropsList.map((el, index) => (
            <FormControlLabel
              data-testid="radioProps"
              disabled={el.disabled || disabled}
              key={index}
              value={el.value}
              label={el.label}
              control={<Radio data-testid="tkRadioItemForTest" />}
              className={lineClassName}
            />
          ))}
        </MuiRadioGroup>
        {!!errorMessage && (
          <FormHelperText error>{errorMessage}</FormHelperText>
        )}
      </FormControl>
      {isGuideMessage && (
        <Box className="guideMessage">
          <Typography>{guideMessage}</Typography>
        </Box>
      )}
    </Box>
  );
};
